import axios from "axios";

import { callGet, callPatch, callPost } from "../../services/axios";
import { toast } from "../../components/CommonComponents/ToastComponent/toast";
const { GOOGLE_AUTH_START, GOOGLE_AUTH_SUCCESS, SAVE_EMAIL_IN_REDUX, GOOGLE_PAGE_TOKEN, MICROSOFT_PAGE_LINK } = require("../actionTypes/emailSettings");

export const saveEmailInRedux = ({ email, domain }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  dispatch({
    type: SAVE_EMAIL_IN_REDUX,
    data: { email: email, domain: domain }
  })
}

export const exchangeCodeForTokens = (code) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/exchangeCodeForTokens`, { code }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const storeGoogleAccessTokenAndProfile = (tokenDetails) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  dispatch({
    type: GOOGLE_AUTH_START,
  })
  return callPost(`/api/emailSettings/getGoogleProfile`, { accessToken: tokenDetails?.access_token }, token).then(async (res) => {
    const domain = res?.data?.emailAddress.split('@')[1];
    let emailDomain = ''
    if (domain === 'gmail.com' || domain === 'googlemail.com') {
      emailDomain = 'google'
    } else {
      emailDomain = 'microsoft'
    }

    dispatch({
      type: GOOGLE_AUTH_SUCCESS,
      data: { authToken: tokenDetails?.access_token, email: res?.data?.emailAddress, expiresIn: tokenDetails?.expires_in, domain: emailDomain }
    })
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getEmailsForAuthGoogleUser = ({ accessToken, refreshToken, email, pageToken, btn, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getEmailsForAuthGoogleUser`, { accessToken, refreshToken, email, pageToken, emailSyncDuration }, token).then(async (res) => {
    dispatch({
      type: GOOGLE_PAGE_TOKEN,
      data: { pageToken: res?.data?.data?.nextPageToken, pageClicked: btn, totalEmailsPerPage: res?.data?.data?.messages.length }
    })
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getEmailDetailsForThreadId = ({ accessToken, messageIds, email, refreshToken, inChunks = false }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getEmailDetailsForThreadId`, { accessToken, messageIds, email, refreshToken, inChunks }, token).then(async (res) => {
    return Promise.resolve(res)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getEmailDetailsForMessageIdForGoogle = ({ accessToken, messageId, email, refreshToken }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getEmailDetailsForMessageIdForGoogle`, { accessToken, messageId, email, refreshToken }, token).then(async (res) => {
    return Promise.resolve(res)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getTrackEmailId = ({ messageId, domain }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getTrackEmailId`, { messageId, domain }, token).then(async (res) => {
    return Promise.resolve(res)
  }).catch(err => {
    return Promise.reject(err)
  })
}


export const checkEmailIfExist = (email) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/checkEmailIfExist`, { email }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const saveAuthenticatedEmail = ({ email, accessToken, refreshToken, expires_in, domain, emailSyncDuration, isReauthenticated, userId }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/saveAuthenticatedEmail`, { email, accessToken, refreshToken, expires_in, domain, emailSyncDuration, isReauthenticated, userId }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getEmailListForUser = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/emailSettings/getEmailListForUser`, token, {}).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err?.message)
  })
}

export const getMicrosoftTokenAndEmails = ({ accessToken, selectedEmail, pageLink, btn, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getMicrosoftTokenAndEmails`, { accessToken, selectedEmail, pageLink, btn, emailSyncDuration }, token).then(async (res) => {
    dispatch({
      type: MICROSOFT_PAGE_LINK,
      data: { pageLink: res?.data?.nextPageLink, pageClicked: btn, totalEmailsPerPage: res?.data?.emails?.length }
    })
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getTotalMicrosoftEmails = ({ accessToken, email }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getTotalMicrosoftEmails`, { accessToken, email }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getTotalGoogleEmails = ({ accessToken, refreshToken, email }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getTotalEmailsForAuthGoogleUser`, { accessToken, refreshToken, email }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getSentEmailsFromGoogle = ({ accessToken, refreshToken, email, pageToken, btn, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getSentEmailsFromGoogle`, { accessToken, refreshToken, email, pageToken, emailSyncDuration }, token).then(async (res) => {    
    dispatch({
      type: GOOGLE_PAGE_TOKEN,
      data: { pageToken: res?.data?.allResults?.nextPageToken, pageClicked: btn, totalEmailsPerPage: res?.data?.allResults?.messages?.length }
    })
    return Promise.resolve(res?.data?.allResults)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getDraftEmailsFromGoogle = ({ accessToken, refreshToken, email, btn, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getDraftEmailsFromGoogle`, { accessToken, refreshToken, email, emailSyncDuration }, token).then(async (res) => {
    dispatch({
      type: GOOGLE_PAGE_TOKEN,
      data: { pageToken: res?.data?.data?.nextPageToken, pageClicked: btn, totalEmailsPerPage: res?.data?.data?.messages.length }
    })
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getSentEmailsFromMicrosoft = ({ accessToken, email, pageLink, btn, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getSentEmailsFromMicrosoft`, { accessToken, email, pageLink, btn, emailSyncDuration }, token).then(async (res) => {
    dispatch({
      type: MICROSOFT_PAGE_LINK,
      data: { pageLink: res?.data?.nextPageLink, pageClicked: btn, totalEmailsPerPage: res?.data?.totalCount }
    })
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const sendEmailByMicrosoft = ({ composedEmail, accessToken, email, type = 'new', msgId = '' }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/sendEmailByMicrosoft`, { composedEmail, accessToken, email, type, msgId }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const sendEmailByGoogle = ({ composedEmail, accessToken, refreshToken, email, type, msgId }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/sendEmailByGoogle`, { composedEmail, accessToken, refreshToken, email, type, msgId }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const modifyEmailAsRead = ({ messageId, accessToken, refreshToken, email }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/modifyEmailAsRead`, { messageId, accessToken, refreshToken, email }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const modifyEmailAsReadForMicrosoft = ({ messageId, accessToken, email }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPatch(`/api/emailSettings/modifyEmailAsReadForMicrosoft`, { messageId, accessToken, email }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getJunkEmailsForMicrosoft = ({ accessToken, email, pageLink, btn, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getJunkEmailsForMicrosoft`, { accessToken, email, pageLink, btn, emailSyncDuration }, token).then(async (res) => {
    dispatch({
      type: MICROSOFT_PAGE_LINK,
      data: { pageLink: res?.data?.nextPageLink, pageClicked: btn, totalEmailsPerPage: res?.data?.totalCount }
    })
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getDraftEmailsForMicrosoft = ({ accessToken, email, pageLink, btn, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getDraftEmailsForMicrosoft`, { accessToken, email, pageLink, btn, emailSyncDuration }, token).then(async (res) => {
    dispatch({
      type: MICROSOFT_PAGE_LINK,
      data: { pageLink: res?.data?.nextPageLink, pageClicked: btn, totalEmailsPerPage: res?.data?.totalCount }
    })
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getSpamEmailsFromGoogle = ({ accessToken, refreshToken, email, pageToken, btn, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getSpamEmailsFromGoogle`, { accessToken, refreshToken, email, pageToken, emailSyncDuration }, token).then(async (res) => {
    dispatch({
      type: GOOGLE_PAGE_TOKEN,
      data: { pageToken: res?.data?.nextPageToken, pageClicked: btn, totalEmailsPerPage: res?.data?.messages.length }
    })
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getRegisteredEmails = (paginatedCallersIds, page = '') => (dispatch, getState) => {
  const { auth: { token, isLoggedIn } } = getState()

  return callPost(`/api/emailSettings/getRegisteredEmails`, { paginatedCallersIds, page }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const updatePhoneNo = (phoneNo) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/updatePhoneNo`, { phoneNo }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getEmailCountsForMicrosoft = ({ email, accessToken, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getEmailCountsForMicrosoft`, { email, accessToken, emailSyncDuration }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getEmailCountsForGoogle = ({ email, accessToken, refreshToken, emailSyncDuration }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getEmailCountsForGoogle`, { email, accessToken, refreshToken, emailSyncDuration }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const contactExistOrNot = (email) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/contactExistOrNot`, { email }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const linkExistingContactToSupplier = ({ typeOfSupplier, supplierId, listSupplierId, contactId }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/linkExistingContactToSupplier`, { typeOfSupplier, supplierId, listSupplierId, contactId }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const createNewContactAndLink = ({ supplierId, listSupplierId, email }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/createNewContactAndLink`, { supplierId, listSupplierId, email }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getDefaultEmail = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/emailSettings/getDefaultEmail`, token, {}).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const trackEmail = ({ messageId, toCreate, domain }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/trackEmail`, { messageId, toCreate, domain }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getTrackEmailMessageIds = (messageIds) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getTrackEmailMessageIds`, { messageIds }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const deleteEmailFromTask = ({ emailConnectionId, domain, supplierId, listSupplierId, emailId, isOutboundEmail, isOutboundEmailRead, isDelete }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/deleteEmailFromTask`, { emailConnectionId, domain, supplierId, listSupplierId, emailId, isOutboundEmail, isOutboundEmailRead, isDelete }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const forwardEmailByGoogle = ({ composedEmail, accessToken, refreshToken, messageIdToForward, email }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/forwardEmailByGoogle`, { composedEmail, accessToken, refreshToken, messageIdToForward, email }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getEmailsForListSupplier = ({ listSupplierEmails, callerRegisteredEmail, domain, accessToken, refreshToken }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getEmailsForListSupplier`, { listSupplierEmails, callerRegisteredEmail, domain, accessToken, refreshToken }, token).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    if (err?.code === "ENOTFOUND" || err?.message.includes("Network Error")) {
      toast.show({
        title: 'Danger',
        description: 'Please Check Your Network And Try Again',
      })
      return Promise.reject(err?.code);
    } else if (err?.response?.status === 500) {
      return Promise.reject(err?.response);
    } else {
      return Promise.reject(err);
    }
  })
}

export const getRegisteredEmailsForCaller = (paginatedCallersIds, isAdmin) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  return callPost(`/api/emailSettings/getRegisteredEmailsForCaller`, { paginatedCallersIds, isAdmin }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const triggerGmailWatch = ({ email, domain, accessToken, refreshToken }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/triggerGmailWatch`, { email, domain, accessToken, refreshToken }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getLastHistoryId = ({ email, domain, accessToken, refreshToken }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getLastHistoryId`, { email, domain, accessToken, refreshToken }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getNewEmailsForGoogle = ({ email, domain, accessToken, refreshToken, socketData }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getNewEmailsForGoogle`, { email, domain, accessToken, refreshToken, socketData }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const createSubscriptionForMicrosoftUser = ({ id, email, domain, accessToken }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/createSubscriptionForMicrosoftUser`, { id, email, domain, accessToken }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getMicrosoftEmailDetails = (email, domain, accessToken, messageId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getMicrosoftEmailDetails`, { email, domain, accessToken, messageId }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getUnreadEmails = (registeredEmail, contactEmail) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getUnreadEmails`, { registeredEmail, contactEmail }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getSubscriptionId = (email) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getSubscriptionId`, { email }, token,).then(async (res) => {
    return Promise.resolve(res)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const subscriptionRenewal = (email, subscriptionId, type, accessToken) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/subscriptionRenewal`, { email, subscriptionId, type, accessToken }, token,).then(async (res) => {
    return Promise.resolve(res)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const saveEmailDetails = (emailConnectionId, domain, supplierId, listSupplierId, emailId, isOutboundEmail, isOutboundEmailRead, outBoundEmailReadDateAndTime, isInBoundEmailRead, inBoundEmailReadDateAndTime, emailChainId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/saveEmailDetails`, { emailConnectionId, domain, supplierId, listSupplierId, emailId, isOutboundEmail, isOutboundEmailRead, outBoundEmailReadDateAndTime, isInBoundEmailRead, inBoundEmailReadDateAndTime, emailChainId }, token,).then(async (res) => {
    return Promise.resolve(res)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const checkGoogleAccessAndRefreshToken = (accessToken, refreshToken) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/checkGoogleAccessAndRefreshToken`, { accessToken, refreshToken }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const saveRecordedMp3File = (formData) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return axios.post(`/api/supplier/saveRecordedMp3File`, formData, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    }
  });
}

export const getUnreadEmailsCount = (domain, callerEmail, contactEmail, accessToken, refreshToken) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getUnreadEmailsCount`, { domain, callerEmail, contactEmail, accessToken, refreshToken }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getLastSentEmailDays = (listSupplierIds) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getLastSentEmailDays`, { listSupplierIds }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getAllOutBoundEmailsCount = (data) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/emailSettings/getAllOutBoundEmailsCount`, { data }, token,).then(async (res) => {
    return Promise.resolve(res?.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

